import Button from "./SecondaryButton";

export default Button;
